export default class DataService {
  _data = {
    test1: "https://youtube.com",
    test2: "https://google.com",
    items: [
      {
        id: "about",
        name: "About.txt",
        icon: "info_bubble",
        content: {
          paragraphs: [
            "Hi! I am a Software Developer based in New Delhi. Currently working in Publicis Sapient as a junior front-end",
            "I like building software solutions to real-life problems and learning new tech and have an experience in react and flutter front-end development",
            "I believe that friendly and respectful communication within a team is key to the company's success. With my experience in software development and database design, I think I would be a valuable asset to your project.",
            "The main technology I have been using is JavaScript. But a few months ago I fell in love with Flutter and I use it for most of my side projects. Moreover, I am in a good relationship with React (this website runs on React btw) and fascinated by Computer Vision and Blockchain.",
            // "When I am not in front of the computer, I usually do yoga, drink a specialty coffee and go on hikes (lake Yoho in Alberta is my favorite trail so far).",
          ],
        },
      },
      {
        id: "resume",
        name: "Resume.txt",
        icon: "notepad_2",
        content: {
          resumeLink:
            "https://drive.google.com/file/d/1IXSYUkuCxveZupsOxOFadcM1PbwIPDsZ/view?usp=sharing",
          workExperience: [
            {
              jobTitle: "Junior Associate Technology",
              company: "Publicis Sapient",
              location: "Gurgaon",
              period: "JUL 2022 – PRESENT",
              accomplishments: [],
            },
            {
              jobTitle: "Engineering Intern",
              company: "Publicis Sapient",
              location: "Gurgaon",
              period: "JAN 2022 – JUL 2022",
              accomplishments: [
                "Scored highest (92.7%) in the coding assessments among 150 interns of the CoreXT interns batch",
                "Worked with NextJS and Typescript on an internal web app dedicated to document and distribute feedbacks and meet- ing notes of a One-On-One among the developers and their managers using Universal React",
                "Implemented the service functions for the app using Axios to enable it to connect with the backend APIs smoothly",
                "Documented the react components with the help of Story- book ® for easier reviewing",
                "ncorporated unit test for all the components in the project us- ing Jest for faster debugging and achieved 87% code coverage over the entire project",
                "Created type interfaces for the props of all the react compo- nents for stronger type checking and preventing unexpected variable values",
              ],
            },
            {
              jobTitle: "Software Engineer Intern",
              company: "WeLinQ",
              location: "London (Remote)",
              period: "JUL 2021 – AUG 2021",
              accomplishments: [
                "Worked on Flutter to create the UI/UX of the feature that allows the user to book a session with a counsellor",
                "Designed the UX flow for the app’s features on Figma",
                "Implemented a payment wall by leveraging flutter’s Stripe package to facilitate smooth in-app transactions",
                "Built an onboarding form to register new counsellors who join the team",
              ],
            },
            {
              jobTitle: "Flutter Intern",
              company: "Youniv",
              location: "Mumbai (Remote)",
              period: "JUN 2021 – AUG 2021",
              accomplishments: [
                "Designed the UI and created custom widgets for 10+ app screens to enhance customer experience",
                "Connected the app to its database using dart’s Provider package using material streams for smooth data flow",
                "Created app’s user database using Google Firestore",
                "Constructed the architecture of the app using the BLoC pat- tern to manage the flow of data through widgets using dart streams",
              ],
            },
            {
              jobTitle: "Flutter Intern",
              company: "GoFoodMan",
              location: "Bangalore (Remote)",
              period: "APR 2021 – JUN 2021",
              accomplishments: [
                "Created the entire UI for the GoFoodMan User app.",
                "Integrated user/restaurant authentication service",
              ],
            },
            {
              jobTitle: "Computer Vision Intern",
              company: "AiBorne Tech",
              location: "",
              period: "AUG 2020 – OCT 2020",
              accomplishments: [
                "Worked on an image classifier that successfully recognizes the user's body orientation.",
                "Created using segmentation by implementing Mask R-CNN technique that superimposes the corresponding angle of the fashion apparel.",
              ],
            },
          ],
          education: [
            {
              credit: "BTech. Computer Science and Engineering",
              place: "Manipal Institute of Technology",
              gpa: "",
              period: "JUL 2018 – JUL 2022",
            },
            {
              credit: "Senior Secondary Education",
              place: "Gyan Ganga International Academy, Bhopal",
              gpa: "",
              period: "2016 – 2018",
            },
            {
              credit: "Secondary Educationn",
              place: "Delhi Public School, Bhopal",
              gpa: "",
              period: "2015 – 2016",
            },
          ],
        },
      },
      {
        id: "projects",
        name: "Projects.txt",
        icon: "flying_through_space_100",
        content: {
          projects: [
            {
              title: "Supr3me News",
              description: [
                "Developed a cross-platform News app that compiles the top articles across various news sources using NewsApi.org",
                "Distributed articles among various categories for the users to choose from",
                "Incorporated search functionality so that the users can find the relevant articles faster",
                "Added WebView that enables the users to read the articles in dark mode",
              ],
              myRole: "",
              techStack: "",
              url: "https://github.com/Supr3me-code/Supr3meNews",
            },
            {
              title: "Youtube Bookmarker",
              description: [
                "A chrome extension that enables you to book- mark important moments from a youtube video for visiting back later",
              ],
              myRole: "",
              techStack: "",
              url: "",
            },
            {
              title: "QR and Barcode scanner using Web Workers",
              description: [
                "A web app that scans QR and barcodes fed through the device camera using web workers running in parallel enhancing efficiency",
              ],
              myRole: "",
              techStack: "",
              url: "",
            },
            {
              title: "Galleria",
              description: [
                "An app that integrates with the user’s device’s gallery and camera",
                "The user can import selected images to Galleria or add more pictures through the lens to your personalized gallery",
              ],
              myRole: "",
              techStack: "",
              url: "",
            },
          ],
        },
      },
      {
        id: "skills",
        name: "Skills.txt",
        icon: "progman_11",
        content: {
          hard: [
            {
              name: "JavaScript",
              // progress: 100,
            },
            {
              name: "HTML/CSS",
            },
            {
              name: "React JS",
            },
            {
              name: "Data Structures",
            },
            {
              name: "Algorithms",
            },
            {
              name: "C++",
            },
            {
              name: "MySQL",
            },
            {
              name: "Flutter (Android)",
            },
            {
              name: "Figma",
            },
            {
              name: "Git",
            },
            {
              name: "Jest",
            },
          ],
          soft: "Analytical thinking, Teamwork, Creative Problem solving, Mangement, Leadership, Entrepreneurship",
        },
      },
      {
        id: "contact",
        name: "Contact.txt",
        icon: "inetcfg_2301",
        content: {
          emailText:
            "If you want to hire me or invite to a project, just email me on ",
          email: "dishantarora16@gmail.com",
          socialText: "Or you can reach me out through social media:",
          social: [
            {
              name: "FaLinkedin",
              link: "https://linkedin.com/in/dishantarora16",
            },
            {
              name: "FaGithub",
              link: "https://github.com/Supr3me-code",
            },
            {
              name: "FaInstagram",
              link: "https://instagram.com/dish_arora?igshid=YmMyMTA2M2Y=",
            },
            {
              name: "FaTwitter",
              link: "https://twitter.com/__supr3me__",
            },
          ],
        },
      },
    ],
  };

  getItems() {
    return this._data.items.map(({ id, name, icon }) => ({ id, name, icon }));
  }

  getItem(id) {
    return this._data.items.find((x) => x.id === id);
  }

  getProjectInfo() {
    return {
      projectRepo: this._data.projectRepo,
      react95Repo: this._data.react95Repo,
    };
  }
}
